/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Commission_Empty_Ledger_BodyInputs */



/**
* | output |
* | --- |
* | "Once a customer you referred is billed, your commission appears here. Share a referral code to get started." |
*
* @param {Partner_Commission_Empty_Ledger_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_commission_empty_ledger_body = /** @type {((inputs?: Partner_Commission_Empty_Ledger_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Commission_Empty_Ledger_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sobald ein von dir geworbener Kunde abgerechnet wird, erscheint deine Provision hier. Teile einen Empfehlungscode, um zu starten.")
	return /** @type {LocalizedString} */ ("Once a customer you referred is billed, your commission appears here. Share a referral code to get started.")
});